import {Stack, Box} from "@mui/material";
import {selectProductCardPropsByIds} from "../../components/marketing/Products/productCatalogAdapter";
import {ProductStack} from "../../components/marketing/Products/ProductStack";
import React from "react";

const TAMALES_PRODUCTS_IDS = [
    "tamale_green_salsa",
    "tamale_street_corn",
    "tamale_red_salsa",
];

export default function TamalesSection() {
    const products = selectProductCardPropsByIds(TAMALES_PRODUCTS_IDS);

    return (
        <Stack spacing={2} sx={{ width: "100%" }}>
            <Box
                sx={{
                    width: "100%",
                    px: { xs: 2, sm: 3, md: 2, lg: 2, xl: 1 },
                    mx: "auto",
                }}
            >
                <ProductStack products={products} />
            </Box>
        </Stack>
    );
}
